// React Router Dom
import {createBrowserRouter} from "react-router-dom";

// Layout
import DefaultLayout, {LoadingBackdrop} from "@/components/Layout/DefaultLayout";
import AuthLayout from "@/components/Layout/AuthLayout";
import ProtectLayout from "@/components/Layout/ProtectLayout";

// Pages
import Account from "@/pages/Account";
import Login from "@/pages/Auth/Login";
import Invitation from "@/pages/Auth/Invitation";
import Impersonation from "@/pages/Auth/Impersonation";
import Register from "@/pages/Auth/Register";
import Home from "@/pages/Home";
import Service from "@/pages/Service";
import ManageConsole from "@/pages/Service/Internal/Internal.Opennebula/Instance/Detail/ManageConsole";
import ResellerManagement from "@/pages/Resellers";
import ResellerCreate from "@/pages/Resellers/Create";
import ResellerDetail from "@/pages/Resellers/Detail";
import ResellerEnrollForm from "@/pages/Resellers/EnrollForm";
import CustomerModule from "@/pages/Resellers/Customers/module";

const routers = createBrowserRouter([
    {
        path: "/",
        element: <ProtectLayout/>,
        children: [
            {
                element: <DefaultLayout/>,
                path: "",
                children: [
                    {
                        path: "",
                        element: <Home/>,
                    }
                ],
            },
            {
                element: <DefaultLayout/>,
                path: "account",
                loader: () => <LoadingBackdrop/>,
                children: [
                    {
                        path: "*",
                        element: <Account/>
                    }
                ],
            },
            {
                element: <DefaultLayout/>,
                path: "services",
                children: [
                    {
                        path: "",
                        element: <Service.Dashboard/>
                    },
                    {
                        path: ":service_uuid/*",
                        element: <Service.Router/>
                    }
                ],
            },
            {
                path: "services/:service_uuid/instances/:instance_id/console",
                element: <ManageConsole/>
            },
            {
                element: <DefaultLayout/>,
                path: "resellers",
                children: [
                    {
                        path: "",
                        element: <ResellerManagement/>
                    },
                    {
                        path: "create",
                        element: <ResellerCreate/>
                    },
                    {
                        path: "detail/:id",
                        element: <ResellerDetail/>
                    },
                    {
                        path: "edit/:id",
                        element: <ResellerCreate/>
                    },
                    {
                        path: "enroll",
                        element: <ResellerEnrollForm/>
                    },
                    {
                        path: "customers/*",
                        element: <CustomerModule />
                    }
                ],
            }
        ],
    },
    {
        path: "/auth",
        element: <AuthLayout/>,
        children: [
            {
                path: "login",
                element: <Login/>,
            },
            {
                path: "register",
                element: <Register/>,
            },
            {
                path: "invitation",
                element: <Invitation/>,
            },
            {
                path: "impersonate",
                element: <Impersonation/>,
            }
        ],
    },
]);

export default routers;
